import React from 'react';
import './StockNews.css';
import {Avatar} from 'antd';
import moment from 'moment';

const StockNewsCard = ({news}) => {
    
    const demoImage = 'https://www.bing.com/th?id=OVFT.mpzuVZnv8dwIMRfQGPbOPC&pid=News';
    return (
        <div className="col-md-4 my-4">
            <a href={news.url} target="_blank" rel="noreferrer">
                <div className="card h-100 d-flex flex-column p-4 shadow justify-content-between">
                    <div className="d-flex justify-content-between align-items-center">
                        <h6>{news.name}</h6>
                        <div className="news-image-box">
                            <img src={news?.image?.thumbnail?.contentUrl || demoImage} alt="news"/>
                        </div>
                    </div>
                    <div className="my-4 news-content">
                        <p>
                            {news.description}
                        </p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                                <Avatar src={news?.provider[0]?.image?.thumbnail?.contentUrl} alt="provider" className="me-2"/>
                                <small>{news?.provider[0]?.name}</small>
                        </div>
                        <small>
                            {moment(news?.datePublished).startOf("ss").fromNow()}
                        </small>   
                    </div>
                </div>
            </a>
        </div>
    )
}

export default StockNewsCard
